import { getInvalidNotesMessage, isValidNotes } from "pages/utils/pageHelper";
import * as yup from "yup";

const requiredMessage: string = "Required";

const newShareValidationSchema = yup.object().shape({
  // Assigned Agency (the agency whose inventory is shared)
  locationFullDisplayName: yup.string().required(""),
  // Sharing Agencies (one or more rows)
  sharingAgencyItems: yup.array().of(
    yup.object().shape({
      locationFullDisplayName: yup.string().required(""),
    })
  ),
  notes: yup.string()
    .nullable()
    .test({
      name: "isValidNotes",
      test: function (value, context) {
        let isValid = true;
        if (value) {
          isValid = isValidNotes(value);
        }
        return isValid ? true : context.createError({ message: getInvalidNotesMessage() });
      }
    })
    .when("isActive", {
      is: 0,
      then: yup.string()
        .nullable()
        .test("required", requiredMessage, (value) => {
          const trimmedValue = value ? value.trim() : '';
          return trimmedValue.length > 0;
        }),
    }),
});

export default newShareValidationSchema;
